import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/RegistrationViewer';

const RegistrationViewerReducer = handleActions({
    [Actions.callApiGetInformationXPAND]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.callApiGetInformationXPANDReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        successInformation: true,
    }),
    [Actions.callApiGetInformationXPANDReceivedFailure]: (state, action) => ({
        ...state,
        errors: action.payload,
        isFetching: false,
        successInformation: false,
    }),
    [Actions.callApiCreateViewer]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.callApiCreateViewerReceived]: (state) => ({
        ...state,
        isFetching: false,
        successCreate: true,
    }),
    [Actions.callApiCreateViewerReceivedFailure]: (state, action) => ({
        ...state,
        errors: action.payload,
        successCreate: false,
        isFetching: false,
    }),
    [Actions.clearDataCreateViewer]: (state) => ({
        ...state,
        successCreate: false,
        isFetching: false,
        errors: {},
    }),
    [Actions.clearGetInfomationData]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
        successInformation: false,
        successCreate: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    successInformation: false,
    successCreate: false,
});
export default combineReducers({
    registrationViewer: RegistrationViewerReducer,
});
